const Dashboard = () => {
  return <div className="bg-g-10 h-[100vh] w-[100vw]">Dashboard</div>;
};

export default Dashboard;
